module.exports = __webpack_public_path__ + "media/images/shared/ebt-logo-transparent-34c0dc4394a802cb4b709a5ea3c79a8794768abb39c674582367ed04856dd2ee.png";